const analyticSectionScopeEnum = Object.freeze({
    ADMIN: 5,
    CUSTOMER: 10,
    PUBLIC: 15,
    PUBLIC_AND_CUSTOMER: 20,
    GENERAL: 25
});
export default analyticSectionScopeEnum;
